module.exports = __webpack_public_path__ + "static/media/ig17.e8e4ecf7.jpg";